import { AuthConfig } from 'angular-oauth2-oidc';

import { environment } from 'src/environments/environment';

export const LAST_ROUTE = 'LAST_ROUTE';

export const AuthCodeFlowConfig: AuthConfig = {
  issuer: environment.authority.issuer,
  redirectUri: environment.authority.redirectUri,
  clientId: environment.authority.clientId,
  responseType: environment.authority.response_type,
  scope: environment.authority.scope,
  showDebugInformation: false,
};
